import { Input } from 'components/ui/input';
import React from 'react';
import { t } from 'utils/getTranslations.ts';
import { isNumeric } from 'utils/number.ts';
import { getSelectorKey } from '../../getSelectorKey.ts';
import { IntervalFilterForm } from '../../ListTableTypes.tsx';
import { FilterLabel } from './FilterLabel';

export const Interval: React.FC<{
    filter: IntervalFilterForm;
    onChange: (value: number | string | null, groupSelector: string, setMin: boolean) => void;
}> = React.memo(({ filter, onChange }) => {
    const onNumericChange = (e: React.ChangeEvent<HTMLInputElement>, setMin: boolean) => {
        // A lone "-" is not a number yet, but a negative bound has to start with it. Serialisation
        // skips the bound until a digit follows.
        if (isNumeric(e.target.value) || e.target.value === '' || e.target.value === '-') {
            onChange(e.target.value, getSelectorKey(filter), setMin);
        }
    };

    return (
        <div className="flex w-full grow flex-col gap-2" key={`filter-${getSelectorKey(filter)}`}>
            <div className="flex w-full flex-row gap-4">
                {filter.minLabel && (
                    <div className="w-full grow">
                        <FilterLabel label={filter.minLabel} tooltip={filter.minTooltip} />
                    </div>
                )}
                {filter.maxLabel && (
                    <div className="w-full grow">
                        <FilterLabel label={filter.maxLabel} tooltip={filter.maxTooltip} />
                    </div>
                )}
            </div>
            <div className="flex w-full flex-row gap-4">
                <Input
                    className="bg-paper flex-1"
                    value={filter?.from ?? ''}
                    aria-label={filter.minLabel}
                    onChange={(e) => onNumericChange(e, true)}
                    placeholder={t(filter.minPlaceholder ?? 'forms.enter-number')}
                />
                <Input
                    className="bg-paper flex-1"
                    value={filter?.to ?? ''}
                    aria-label={filter.maxLabel}
                    onChange={(e) => onNumericChange(e, false)}
                    placeholder={t(filter.maxPlaceholder ?? 'forms.enter-number')}
                />
            </div>
        </div>
    );
});
